import React from 'react';
import ChangeStatus from '@mui/icons-material/ImportExport';
import SendIcon from '@mui/icons-material/Send';
import RejectQuote from '@mui/icons-material/HighlightOff';
import {
  PaymentInputOption,
  QuoteStatus,
  QuotesIconStatusAndColor,
  QuoteMultiEquipment,
  QuoteModality
} from 'src/utils/constants/quotes';
import { getClientFullName } from 'src/utils/common';
import selectFormatDate from 'src/utils/selectDateFormat';
import dateFormatType from 'src/utils/dateFormatType';
import ArchiveIcon from '@mui/icons-material/Archive';
import FileOpenIcon from '@mui/icons-material/FileOpen';
import StatusIcon from 'src/components/StatusIcon';
import { GracePeriodValues } from 'src/utils/constants/distributors';
import { CaseOptions } from 'src/utils/constants/buroForm';
import IconStatusAndColor from 'src/utils/constants/common';
import { Tooltip } from '@mui/material';

export const QuoteActions = {
  SEE_DOCUMENT: 'SEE_DOCUMENT',
  CONTRACT_REQUEST: 'CONTRACT_REQUEST',
  SEND_TO_CONTRACT: 'SEND_TO_CONTRACT',
  REJECT_QUOTE: 'REJECT_QUOTE',
  ARCHIVE: 'ARCHIVE',
  ASSIGN_KAM: 'ASSIGN_KAM',
  ASSIGN_CLIENT: 'ASSIGN_CLIENT',
  SEND_TO_WHATSAPP: 'SEND_TO_WHATSAPP'
};

export const backgroundColorOfQuotesStatus = {
  REJECTED: '#df4d491a',
  ARCHIVED: '#e6e6e6',
  ACCEPTED: 'rgba(46, 187, 11, 0.1)',
  DRAFT: '#e6e6e6',
  IN_REVIEW: '#ffffe1',
  DEFAULT: '#e6e6e6'
};

export const QuoteTypes = {
  MSI: 'MSI',
  NOR: 'NOR',
  FIRST_UPFRONT_RENT: 'PF'
};

export const QuoteSection = {
  GENERAL: 'GENERAL',
  RENT_DATA: 'RENT_DATA'
};

export const getAdminQuotesMenuOptions = (
  document,
  status,
  distributorProfile,
  pendingDocs,
  sentForClientApproval
) => {
  switch (status) {
    case QuoteStatus.IN_REVIEW:
      return [
        {
          name: QuoteActions.SEE_DOCUMENT,
          label: `ENUMS.QUOTE_ACTIONS.${QuoteActions.SEE_DOCUMENT}`,
          disabled: !document,
          icon: <FileOpenIcon />
        },
        {
          name: QuoteActions.SEND_TO_CONTRACT,
          label: `ENUMS.QUOTE_ACTIONS.${QuoteActions.SEND_TO_CONTRACT}`,
          icon: <SendIcon />,
          // this is a temporary solution, we need to check if the quote has pending documents
          /* disabled: pendingDocs ? Boolean(pendingDocs.number) : false, */
          message: pendingDocs ? pendingDocs.message : null
        },
        {
          name: QuoteActions.REJECT_QUOTE,
          label: `ENUMS.QUOTE_ACTIONS.${QuoteActions.REJECT_QUOTE}`,
          icon: <RejectQuote />
        }
      ];
    case QuoteStatus.DRAFT:
      if (!distributorProfile) {
        return [
          {
            name: QuoteActions.SEE_DOCUMENT,
            label: `ENUMS.QUOTE_ACTIONS.${QuoteActions.SEE_DOCUMENT}`,
            disabled: !document,
            icon: <FileOpenIcon />
          },
          {
            name: QuoteActions.SEND_TO_WHATSAPP,
            label: `ENUMS.QUOTE_ACTIONS.${QuoteActions.SEND_TO_WHATSAPP}`,
            icon: <SendIcon />
          },
          {
            name: QuoteActions.CONTRACT_REQUEST,
            label: !sentForClientApproval
              ? `ENUMS.QUOTE_ACTIONS.${QuoteActions.CONTRACT_REQUEST}`
              : `ENUMS.QUOTE_ACTIONS.RESEND_CONTRACT_REQUEST`,
            icon: <ChangeStatus />
          },
          {
            name: QuoteActions.ASSIGN_KAM,
            label: `ENUMS.QUOTE_ACTIONS.${QuoteActions.ASSIGN_KAM}`,
            icon: <ChangeStatus />
          },
          {
            name: QuoteActions.ARCHIVE,
            label: `ENUMS.QUOTE_ACTIONS.${QuoteActions.ARCHIVE}`,
            icon: <ArchiveIcon />
          }
        ];
      }
      return [
        {
          name: QuoteActions.SEE_DOCUMENT,
          label: `ENUMS.QUOTE_ACTIONS.${QuoteActions.SEE_DOCUMENT}`,
          disabled: !document,
          icon: <FileOpenIcon />
        },
        {
          name: QuoteActions.SEND_TO_WHATSAPP,
          label: `ENUMS.QUOTE_ACTIONS.${QuoteActions.SEND_TO_WHATSAPP}`,
          icon: <SendIcon />
        },
        {
          name: QuoteActions.CONTRACT_REQUEST,
          label: !sentForClientApproval
            ? `ENUMS.QUOTE_ACTIONS.${QuoteActions.CONTRACT_REQUEST}`
            : `ENUMS.QUOTE_ACTIONS.RESEND_CONTRACT_REQUEST`,
          icon: <ChangeStatus />
        }
      ];
    default:
      return [
        {
          name: QuoteActions.SEE_DOCUMENT,
          label: `ENUMS.QUOTE_ACTIONS.${QuoteActions.SEE_DOCUMENT}`,
          disabled: !document,
          icon: <FileOpenIcon />
        }
      ];
  }
};

export const getUserQuotesMenuOptions = (
  document,
  status,
  sentForClientApproval
) => {
  if (status === QuoteStatus.DRAFT) {
    return [
      {
        name: QuoteActions.SEE_DOCUMENT,
        label: `ENUMS.QUOTE_ACTIONS.${QuoteActions.SEE_DOCUMENT}`,
        disabled: !document,
        icon: <FileOpenIcon />
      },
      {
        name: QuoteActions.CONTRACT_REQUEST,
        label: !sentForClientApproval
          ? `ENUMS.QUOTE_ACTIONS.${QuoteActions.CONTRACT_REQUEST}`
          : `ENUMS.QUOTE_ACTIONS.RESEND_CONTRACT_REQUEST`,
        icon: <ChangeStatus />
      },
      {
        name: QuoteActions.ARCHIVE,
        label: `ENUMS.QUOTE_ACTIONS.${QuoteActions.ARCHIVE}`,
        icon: <ArchiveIcon />
      }
    ];
  }
  return [
    {
      name: QuoteActions.SEE_DOCUMENT,
      label: `ENUMS.QUOTE_ACTIONS.${QuoteActions.SEE_DOCUMENT}`,
      disabled: !document,
      icon: <FileOpenIcon />
    }
  ];
};

export const getBrandModelName = (brand, model, t) =>
  `${
    brand.name === QuoteMultiEquipment.MULTIEQUIPMENT &&
    model === QuoteMultiEquipment.MULTIEQUIPMENT
      ? `${t('ENUMS.QUOTE_MULTIEQUIPMENT.MULTIEQUIPMENT')}`
      : `${brand.name} - ${model}`
  }`;
export const getQuoteFileName = (client, brand, model, createdAt, t) =>
  `Cotizacion - ${getClientFullName(client)} - Equipo ${getBrandModelName(
    brand,
    model,
    t
  )} - ${selectFormatDate(createdAt, dateFormatType.DAY)}.pdf`;

export const getInitialPaymentAmount = (
  priceWithIva,
  initialPayment,
  paymentInputOption
) => {
  if (paymentInputOption === PaymentInputOption.AMOUNT) {
    return initialPayment;
  }
  const initialPaymentAmount = priceWithIva * (initialPayment / 100);
  return initialPaymentAmount;
};

export const translateGracePeriodValueToDaysForFirstRent = (gracePeriod, t) => {
  if (gracePeriod < 0) {
    return `${t('ENUMS.DAYS_FOR_FIRST_RENT.SAME_DAY_AS_CONTRACT_STARTS')}`;
  }

  return `${gracePeriod + 30} ${t('COMMON.DAYS')}`;
};

export const selectBackGroundColorFromQuoteStatus = quote => {
  switch (quote.status) {
    case QuoteStatus.REJECTED:
      return backgroundColorOfQuotesStatus.REJECTED;
    case QuoteStatus.ARCHIVED:
      return backgroundColorOfQuotesStatus.ARCHIVED;
    case QuoteStatus.ACCEPTED:
      return backgroundColorOfQuotesStatus.ACCEPTED;
    case QuoteStatus.DRAFT:
      return backgroundColorOfQuotesStatus.DRAFT;
    case QuoteStatus.IN_REVIEW:
      return backgroundColorOfQuotesStatus.IN_REVIEW;
    default:
      return backgroundColorOfQuotesStatus.DEFAULT;
  }
};

export const handleInitialPaymentChange = (
  e,
  setFieldValue,
  msiChecked,
  defaultGracePeriod = null
) => {
  const amount = Number(e.target.value);
  setFieldValue('initialPayment', amount);
  if (amount === 0) {
    setFieldValue('gracePeriod', GracePeriodValues.SAME_DAY_AS_CONTRACT_STARTS);
  } else if (amount > 0 && msiChecked) {
    setFieldValue('gracePeriod', GracePeriodValues.ZERO);
  } else if (amount > 0 && defaultGracePeriod !== null) {
    setFieldValue('gracePeriod', Number(defaultGracePeriod));
  }
};

export const getQuoteStatusIcon = quote => {
  switch (quote.status) {
    case QuoteStatus.ACCEPTED:
      return (
        <StatusIcon
          description="ENUMS.QUOTE_STATUS.ACCEPTED"
          type={QuotesIconStatusAndColor.OK.status}
          color={QuotesIconStatusAndColor.OK.color}
        />
      );

    case QuoteStatus.ARCHIVED:
      return (
        <StatusIcon
          description="ENUMS.QUOTE_STATUS.ARCHIVED"
          type={QuotesIconStatusAndColor.ERROR.status}
          color={QuotesIconStatusAndColor.ERROR.color}
        />
      );
    case QuoteStatus.IN_REVIEW:
      return (
        <StatusIcon
          description="ENUMS.QUOTE_STATUS.IN_REVIEW"
          type={QuotesIconStatusAndColor.WARNING.status}
          color={QuotesIconStatusAndColor.WARNING.color}
        />
      );
    case QuoteStatus.REJECTED:
      return (
        <StatusIcon
          description="ENUMS.QUOTE_STATUS.REJECTED"
          type={QuotesIconStatusAndColor.ERROR.status}
          color={QuotesIconStatusAndColor.WARNING.color}
        />
      );
    case QuoteStatus.DRAFT:
      return (
        <StatusIcon
          description="ENUMS.QUOTE_STATUS.DRAFT"
          type={QuotesIconStatusAndColor.NONE.status}
        />
      );
    default:
      return (
        <StatusIcon
          description="COMMON.NO_DATA"
          type={QuotesIconStatusAndColor.NONE.status}
        />
      );
  }
};

export const shouldDisableGracePeriod = (
  isLoadingDistributorParameter,
  modality,
  initialPayment
) => {
  const isGracePeriodCondition =
    modality !== QuoteModality.FIRST_UPFRONT_RENT &&
    Number(initialPayment) === 0;

  return (
    isLoadingDistributorParameter ||
    isGracePeriodCondition ||
    modality === QuoteModality.MSI
  );
};
export const getQuoteType = quote => {
  if (quote.isMsiModality) {
    return QuoteTypes.MSI;
  }
  if (quote.isFirstUpfrontRentModality) {
    return QuoteTypes.FIRST_UPFRONT_RENT;
  }
  return QuoteTypes.NOR;
};

export const getBuroValidationStatusText = buroStatus => {
  switch (buroStatus) {
    case CaseOptions.WITHOUT_AVAL:
      return 'CLIENTS_VIEW.CLIENT_DETAIL.FINANCING_STATUS.APPROVED_NO_AVAL';
    case CaseOptions.WITH_AVAL:
      return 'CLIENTS_VIEW.CLIENT_DETAIL.FINANCING_STATUS.APPROVED_WITH_AVAL';
    case CaseOptions.DENIED:
      return 'CLIENTS_VIEW.CLIENT_DETAIL.FINANCING_STATUS.DENIED';
    case CaseOptions.REVIEW:
      return 'CLIENTS_VIEW.CLIENT_DETAIL.FINANCING_STATUS.IN_REVIEW';
    default:
      return 'CLIENTS_VIEW.CLIENT_DETAIL.FINANCING_STATUS.NO_DATA';
  }
};

export const getBuroValidationIconType = buroStatus => {
  switch (buroStatus) {
    case CaseOptions.WITHOUT_AVAL:
      return (
        <StatusIcon
          description="CLIENTS_VIEW.CLIENT_DETAIL.FINANCING_STATUS.APPROVED_NO_AVAL"
          type={IconStatusAndColor.OK.status}
        />
      );
    case CaseOptions.WITH_AVAL:
      return (
        <StatusIcon
          description="CLIENTS_VIEW.CLIENT_DETAIL.FINANCING_STATUS.APPROVED_WITH_AVAL"
          type={IconStatusAndColor.OK.status}
        />
      );
    case CaseOptions.DENIED:
      return (
        <StatusIcon
          description="CLIENTS_VIEW.CLIENT_DETAIL.FINANCING_STATUS.DENIED"
          type={IconStatusAndColor.ERROR.status}
        />
      );
    case CaseOptions.REVIEW:
      return (
        <Tooltip>
          <StatusIcon
            description="CLIENTS_VIEW.CLIENT_DETAIL.FINANCING_STATUS.IN_REVIEW"
            type={IconStatusAndColor.WARNING.status}
          />
        </Tooltip>
      );
    default:
      return (
        <StatusIcon
          description="CLIENTS_VIEW.CLIENT_DETAIL.FINANCING_STATUS.NO_DATA"
          type={IconStatusAndColor.NONE.status}
        />
      );
  }
};

export const normalizeText = value =>
  (value || '')
    .trim()
    .replace(/\s+/g, ' ')
    .toLowerCase();

export const resolveEquipmentPayload = (current, original) => {
  const currentBrand = current.brand?.trim() || '';
  const currentModel = current.model?.trim() || '';
  const originalBrand = original?.brand?.name || original?.brand || '';
  const originalModel = original?.model || '';

  return {
    brandId:
      current.brandId ?? original?.brand?.id ?? original?.brandId ?? null,
    brand: currentBrand,
    model: currentModel,
    isBrandChanged:
      normalizeText(currentBrand) !== normalizeText(originalBrand),
    isModelChanged: normalizeText(currentModel) !== normalizeText(originalModel)
  };
};
